import { memo } from "react";

import { tw, type TTailwindString } from "classnames";

const styles = {
  wrapper: tw(
    "placeholder" as TTailwindString,
    "w-full",
    "animate-fade-in",
    "overflow-hidden"
  ),
  header: tw("flex", "items-center", "gap-2", "px-6", "pb-3"),
  heading: tw(
    "box-border",
    "h-4",
    "w-28",
    "animate-pulse",
    "rounded",
    "bg-placeholder"
  ),
  badge: tw(
    "box-border",
    "h-4",
    "w-18",
    "animate-pulse",
    "rounded",
    "bg-placeholder"
  ),
  carousel: tw(
    "flex",
    "flex-nowrap",
    "gap-2",
    "px-6",
    "md:gap-4",
    "list-none",
    "m-0"
  ),
  item: tw(
    "flex",
    "w-[295px]" as TTailwindString,
    "flex-shrink-0",
    "bg-white",
    "rounded-[4px]" as TTailwindString,
    "px-2",
    "py-2.5"
  ),
  image: tw(
    "box-border",
    "animate-pulse",
    "mr-2",
    "h-[106px]" as TTailwindString,
    "w-[84px]" as TTailwindString,
    "bg-background-secondary"
  ),
  content: tw("flex", "flex-1", "flex-col"),
  contentText: tw("flex-1", "flex", "flex-col", "gap-1"),
  contentFooter: tw("flex", "justify-between", "items-center", "gap-1"),
  price: tw(
    "box-border",
    "animate-pulse",
    "rounded",
    "bg-placeholder",
    "w-10",
    "h-5"
  ),
  variantCta: tw(
    "box-border",
    "animate-pulse",
    "rounded",
    "bg-placeholder",
    "flex-1",
    "rounded-5xl",
    "h-6"
  ),
  cta: tw(
    "box-border",
    "animate-pulse",
    "rounded",
    "bg-placeholder",
    "w-18",
    "rounded-5xl",
    "h-6"
  ),
  itemHeading: tw(
    "box-border",
    "animate-pulse",
    "rounded",
    "bg-placeholder",
    "w-1/2",
    "h-6"
  ),
  itemParagraph1: tw(
    "box-border",
    "animate-pulse",
    "rounded",
    "bg-placeholder",
    "w-full",
    "h-2"
  ),
  itemParagraph2: tw(
    "box-border",
    "animate-pulse",
    "rounded",
    "bg-placeholder",
    "w-1/5",
    "h-2"
  ),
};

const CartUpsellPlaceholderItem = () => {
  return (
    <li>
      <div className={styles.item}>
        <div className={styles.image}></div>
        <div className={styles.content}>
          <div className={styles.contentText}>
            <div className={styles.itemHeading}></div>
            <div className={styles.itemParagraph1}></div>
            <div className={styles.itemParagraph2}></div>
            <div className={styles.price}></div>
          </div>
          <div className={styles.contentFooter}>
            <div className={styles.variantCta}></div>
            <div className={styles.cta}></div>
          </div>
        </div>
      </div>
    </li>
  );
};

const CartUpsellPlaceholderBase = () => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.header}>
        <div className={styles.heading}></div>
        <div className={styles.badge}></div>
      </div>

      <ul className={styles.carousel}>
        {Array.from({ length: 2 }).map((_, index) => (
          <CartUpsellPlaceholderItem key={index} />
        ))}
      </ul>
    </div>
  );
};

export const CartUpsellPlaceholder = memo(CartUpsellPlaceholderBase);
